export default __webpack_public_path__ + "static/media/fox.68e10ead.gif";